import React from "react";
import { createRoot, Root } from "react-dom/client";
import App from "./App";

const rootElement: HTMLDivElement = document.getElementById(
  "search-bond-form"
) as HTMLDivElement;
const root: Root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
